export default __webpack_public_path__ + "static/media/331.1e9cb5b6.png";